import React, { useState } from "react";
import { navigate } from "gatsby";
import $ from 'jquery'

function SearchResultsPagination(props) {
    const [pagenumber, setPageNumber] = useState(props.current_page_number);

    const nextpage = event => {
        if((props.current_page_number !== props.number_of_pages)){
            setPageNumber((props.current_page_number) + 1)
            let pageUrl = 'page-' + ((props.current_page_number) + 1) + '/';
            //get current url
            const urlwithoutsort = (props?.location_path).split("page-");
            // concat url and navigate
            navigate(urlwithoutsort[0] + pageUrl)
            var target = $("body");
            $('html,body').animate({
                scrollTop: target.offset().top - 250
            }, 100);
        }
      
    }
    return (
        <section   className={`more-results`} >
            <button 
                className={`more ${(props.current_page_number === props.number_of_pages) ? "disable" : "active"} `}
                id="mynextbut"
                onClick={nextpage}
            // disabled={!hasMore}
            >
                Next <i className="icon-chevron-right"></i>
            </button>
        </section>
    );
}

export default SearchResultsPagination